import _ from "lodash";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
    video: _.get(data, "desktop_video"),
    imageBanner: _.get(data, "media_desktop_image_data.full_file_path"),
    imageBannerMobile: _.get(data, "media_mobile_image_data.full_file_path"),
    shows: _.map(_.get(data, "shows"), show => {
      return {
        ...show,
        title: _.get(show, "title"),
        subtitle: _.get(show, "subtitle"),
        description: _.get(show, "detail"),
        image: _.get(show, "media_image_data.full_file_path")
      };
    })
  };
};

const fetchOurshowPageApi = () => {
  return fetchApi("page/ourshow")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchOurshowPageApi };



// WEBPACK FOOTER //
// ./src/services/page/ourshowpage.js